import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import BookKeeping from "@/pages/BookKeeping";
import VirtualAssistance from "@/pages/VirtualAssistance";
import MarketingAssistance from "@/pages/MarketingAssistance";
import CustomerSupport from "@/pages/CustomerSupport";
import OurTeam from "@/pages/OurTeam";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/bookkeeping-services" element={<BookKeeping />} />
          <Route path="/virtual-assistant-services" element={<VirtualAssistance />} />
          <Route path="/marketing-assistance" element={<MarketingAssistance />} />
          <Route path="/customer-support" element={<CustomerSupport />} />
          <Route path="/our-team" element={<OurTeam />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          {/* Hidden blog — reachable only by direct URL (not in nav/footer) */}
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blogs/:slug" element={<BlogPost />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
